import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  Button,
  message,
  Card,
  DatePicker,
  Upload,
  Form,
  Spin,
  Popconfirm,
  Steps,
} from "antd";
import { getParmUrl, isPdf, tokenConfig } from "@/public/utils";
import _, { get } from "lodash";
import common from "@/public/common";
import moment from "moment";
import "moment/locale/zh-cn";
import { UploadOutlined } from "@ant-design/icons";
import {
  queryQualificationDetailApi,
  saveQualificationDetailApi,
  baseInfoScsStatusQuery,
} from "./../service";
import { getCookie } from "@/public/utils";
import AuditInformation from "../supplierinformationentry/audit-information";
import ImgPreView from "@/compenents/imgPreView";
import StepsComponents from "./../components/steps";
import "../supplierinformationentry/common.less";
import {
  transformQueryData,
  transformSaveData,
  createHandleChangeInput,
  createHandelSelect,
  createHandleChangeDate,
  createHandleChangeResponsibility,
  createHandleDeleteImage,
  createHandleChangeFileAuthorize,
  createHandleDeleteFile,
  createOnPreview,
  createCheckQualificationsData,
  getShow,
} from "../supplierinformationentry/qualification-util";

var apihost = common.scpUrl;
var { Option } = Select;

var ComplianceCertification = function (props) {
  // 初始步骤：URL 带 current 参数用之，否则 0（填写资质）；兜底 NaN 为 0
  var [currentNum, setCurrentNum] = useState(function () {
    var init = getParmUrl("current");
    if (init === null || init === undefined || init === "" || isNaN(init * 1)) {
      return 0;
    }
    return init * 1;
  });
  var [qualificationData, setQualificationData] = useState([]);
  var [loading, setLoading] = useState(false);
  var [previewVisible, setPreviewVisible] = useState(false);
  var [preViewImgList, setPreViewImgList] = useState([]);
  var [auditInfo, setAuditInfo] = useState({});
  var [showWait, setShowWait] = useState(false);
  var disabledStatus = !!getParmUrl("stepaction");

  useEffect(function () {
    queryQualificationFunc();
    getSupplierInformation();
  }, []);

  // 查询资质数据
  var queryQualificationFunc = async function () {
    setLoading(true);
    try {
      var res = await queryQualificationDetailApi({
        operator_system: "scs",
        need_query_on_change: true,
        charge_code_list: [],
        now: moment(),
        change_code: "",
        need_match_change: false,
        supplier_code: getCookie("supplier_code") || "",
        need_query_charge_qua: true,
        is_only_config_qua: false, // 合规资质补充时传 false
      });
      setLoading(false);
      if (res.data.code == "0" && get(res, "data.data")) {
        var newData = get(res, "data.data");
        var data = transformQueryData(newData);
        setQualificationData(data);
      }
    } catch (err) {
      setLoading(false);
      setQualificationData([]);
    }
  };

  // 查询状态（走新版 erp-srm-sqm-service 接口）
  // forceShowWait: 提交成功后调用时传 true，跳步骤1显示提交成功页（避免闭包读到旧的 showWait）
  var getSupplierInformation = async function (forceShowWait) {
    var supplierCode = getCookie("supplier_code");
    if (!supplierCode) {
      message.error("未获取到供应商编码，无法查询状态");
      return;
    }
    try {
      var res = await baseInfoScsStatusQuery({
        supplier_code: supplierCode,
      });
      if (res.data.code == "0") {
        var auditInfo = {
          ...get(res, "data.data"),
        };
        setAuditInfo(auditInfo);
        // 能进入合规认证页说明基础信息已审核通过，默认停在步骤0（填写资质）。
        // 仅当状态还处于基础信息阶段（待提交/待审核）时拦回步骤0并提示；
        // FinalAuditRefused 终审拒绝（资质退回）的用户正是要重新填资质，不拦截；
        // 刚提交完资质（forceShowWait 或 showWait）跳步骤1 显示提交成功页
        var supplierStatus = get(res, "data.data.supplier_status");
        var baseInfoStatusList = [
          "ScsBaseWaitSubmit",
          "ScsBaseWaitAudit",
        ];
        if (baseInfoStatusList.includes(supplierStatus)) {
          message.warning("基础信息尚未审核通过，请先完成基础信息的填写和审核");
          setCurrentNum(0);
        } else if (forceShowWait || showWait) {
          // 资质刚提交成功（待审核），显示提交成功页
          setCurrentNum(1);
        }
      }
    } catch (err) {
      return null;
    }
  };

  // 公共 handler（从 qualification-util 工厂创建）
  var handleChangeInput = createHandleChangeInput(qualificationData, setQualificationData);
  var handelSelect = createHandelSelect(qualificationData, setQualificationData);
  var handleChangeDate = createHandleChangeDate(qualificationData, setQualificationData);
  var handleChangeResponsibility = createHandleChangeResponsibility(qualificationData, setQualificationData);
  var handleDeleteImage = createHandleDeleteImage(qualificationData, setQualificationData);
  var handleChangeFileAuthorize = createHandleChangeFileAuthorize(qualificationData, setQualificationData);
  var handleDeleteFile = createHandleDeleteFile(qualificationData, setQualificationData);
  var onPreview = createOnPreview(setPreViewImgList, setPreviewVisible);
  var checkQualificationsData = createCheckQualificationsData(qualificationData);

  // 保存 / 提交
  var handleSave = async function (isSubmit) {
    if (isSubmit && !checkQualificationsData()) {
      return;
    }
    setLoading(true);
    try {
      var saveData = transformSaveData(qualificationData);
      var res = await saveQualificationDetailApi({
        supplier_code: getCookie("supplier_code") || "",
        qualification_list: saveData,
        is_submit: isSubmit,
        operator_system: "scs",
        now: moment(),
      });
      setLoading(false);
      if (res.data.code == "0") {
        if (isSubmit) {
          message.success("合规资质提交成功");
          // 提交成功后重新查询状态，按最新 supplier_status 跳到正确步骤（跳提交成功页）
          setShowWait(true);
          getSupplierInformation(true);
        } else {
          message.success("合规资质保存成功");
          queryQualificationFunc();
        }
      } else {
        message.error(res.data.message || "");
      }
    } catch (err) {
      setLoading(false);
      message.error("操作失败");
    }
  };

  // 渲染资质数据
  var renderQualificationData = function () {
    if (!qualificationData || qualificationData.length === 0) return null;
    return qualificationData.map(function (item, index) {
      return (
        <div key={index}>
          {item.qua_value
            ? item.qua_value.map(function (item2, index2) {
                var timeFields = item2.filter(function (v) {
                  return (
                    v.qua_filed_name === "开始时间" ||
                    v.qua_filed_name === "结束时间"
                  );
                });
                var otherFields = item2.filter(function (v) {
                  return (
                    v.qua_filed_name !== "开始时间" &&
                    v.qua_filed_name !== "结束时间"
                  );
                });
                return (
                  <div
                    key={index2}
                    style={{
                      border: "1px solid #e8e8e8",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          marginBottom: "8px",
                          lineHeight: "32px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            textAlign: "right",
                            width: "100px",
                          }}
                        >
                          {item.is_need === 1 ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : null}
                          资质名称：
                        </span>
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          {item.qua_name || "-"}
                        </span>
                        <span style={{ marginLeft: "8px" }}>
                          {getShow(item.qua_name)}
                        </span>
                      </div>
                      {timeFields.length > 0 && (
                        <div
                          style={{
                            width: "50%",
                            marginBottom: "8px",
                            lineHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              textAlign: "right",
                              width: "100px",
                            }}
                          >
                            {timeFields[0].is_need ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                            有效时间：
                          </span>
                          {timeFields.map(function (m, n) {
                            var dateValue = null;
                            // is_match_change 为 true 严格取变更后的值（没填就显示空），为 false 取原值
                            var dateField = m.is_match_change
                              ? m.change_after_field_name
                              : m.qua_filed_value;
                            if (dateField) {
                              if (typeof dateField === "string") {
                                dateValue = moment(dateField);
                              } else {
                                dateValue = moment(dateField * 1);
                              }
                            }
                            return (
                              <span key={n}>
                                <DatePicker
                                  format="YYYY-MM-DD"
                                  style={{
                                    width: "144px",
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                  disabled={disabledStatus}
                                  placeholder={
                                    m.qua_filed_name === "开始时间"
                                      ? "选择开始时间"
                                      : "选择结束时间"
                                  }
                                  onChange={function (e) {
                                    handleChangeDate(
                                      e,
                                      index,
                                      index2,
                                      m.qua_filed_name,
                                    );
                                  }}
                                  value={dateValue}
                                />
                              </span>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    {otherFields.map(function (item3, index3) {
                      return (
                        <div
                          key={index3}
                          style={{
                            width: "50%",
                            marginBottom: "8px",
                            display: "inline-block",
                            verticalAlign: "top",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              textAlign: "right",
                              width: "100px",
                            }}
                          >
                            {item3.is_need ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                            {item3.qua_filed_name}：
                          </span>
                          {item3.qua_filed_type === "Text" && (
                            <Input
                              placeholder="请输入"
                              disabled={disabledStatus}
                              value={
                                item3.is_match_change
                                  ? item3.change_after_field_name || ""
                                  : item3.qua_filed_value &&
                                      item3.qua_filed_value !== "null"
                                    ? item3.qua_filed_value
                                    : ""
                              }
                              onChange={function (e) {
                                handleChangeInput(
                                  e,
                                  index,
                                  index2,
                                  item3.qua_filed_name,
                                );
                              }}
                              style={{
                                width: "296px",
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                          )}
                          {item3.qua_filed_type === "Picture" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept="image/jpeg,image/jpg,image/png"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeResponsibility(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.imgList || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传图片
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                .jpg,.jpeg,.png
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "File" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept=".pdf"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeFileAuthorize(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.fileListNew || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传文件
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                仅支持.pdf
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "Picture&File" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept=".pdf,image/jpeg,image/jpg,image/png"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeFileAuthorize(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.fileListNew || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传文件
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                .pdf,.jpg,.jpeg,.png
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "Select" && (
                            <Select
                              showSearch
                              style={{
                                width: 272,
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                              optionFilterProp="children"
                              placeholder="请选择"
                              disabled={disabledStatus}
                              value={
                                item3.is_match_change
                                  ? item3.change_after_field_name
                                  : item3.qua_filed_value
                              }
                              onChange={function (e) {
                                handelSelect(
                                  e,
                                  index,
                                  index2,
                                  item3.qua_filed_name,
                                );
                              }}
                            >
                              <Option key={0} value={0}>
                                不校验
                              </Option>
                              <Option key={1} value={1}>
                                强校验
                              </Option>
                            </Select>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })
            : null}
        </div>
      );
    });
  };

  var handleJump = function () {
    var url =
      window.location.origin +
      "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection";
    window.open(url);
  };

  return (
    <div style={{ marginTop: "24px" }}>
      <Card style={{ width: "100%", marginBottom: "16px" }}>
        <StepsComponents current={1} stepChange={handleJump} />
      </Card>

      <Card style={{ width: "100%" }}>
        <Steps current={currentNum}>
          <Steps.Step title="填写其他合规资质" description="" />
          <Steps.Step title="提交视客复审" description="" />
        </Steps>
        <Spin spinning={loading}>
          {currentNum == 0 && (
            <div style={{ fontSize: 16 }}>
              <div
                style={{
                  width: "96%",
                  marginLeft: "2%",
                  display: currentNum == 0 ? "inline-block" : "none",
                  padding: "12px 0",
                }}
              >
                <span
                  style={{
                    display: disabledStatus ? "none" : "inline-block",
                  }}
                  className="mr16"
                >
                  <a
                    href={
                      common.fileUrl +
                      "erp/zizhi/file/" +
                      (common.env == "production"
                        ? "1712739855136.rar"
                        : "1712739461507.rar")
                    }
                    onClick={function () {
                      message.success("正在下载文件，请稍等！");
                    }}
                  >
                    批量下载资质模板
                  </a>
                </span>
                <span style={{ color: "red" }}>
                  注：上传图片及文件需加盖公司红章，多页文件附件需加盖骑缝章
                </span>
              </div>

              <div style={{ color: "red" }}>注：请上传带公章图片</div>
              {renderQualificationData()}

              <ImgPreView
                previewVisible={previewVisible}
                onClose={function () {
                  setPreviewVisible(false);
                }}
                previewIndex={0}
                imgList={preViewImgList}
              />

              <div
                style={{
                  width: "100%",
                  marginBottom: "24px",
                  marginTop: "56px",
                  textAlign: "center",
                }}
              >
                <Button
                  type=""
                  style={{ margin: "0px 8px" }}
                  onClick={function () {
                    handleSave(false);
                  }}
                  shape="round"
                  disabled={disabledStatus}
                >
                  保存
                </Button>
                <Popconfirm
                  title={
                    <div>
                      确认提交吗？
                      <p>
                        合规资质提交后，您将无法再对资质进行修改，请确认填写无误后再提交
                      </p>
                    </div>
                  }
                  onConfirm={function () {
                    handleSave(true);
                  }}
                  okText="确定"
                  cancelText="取消"
                >
                  <Button
                    type="primary"
                    style={{ margin: "0px 8px" }}
                    shape="round"
                    disabled={disabledStatus}
                  >
                    提交审核
                  </Button>
                </Popconfirm>
              </div>
            </div>
          )}
          {currentNum == 1 && (
            <AuditInformation showWait={showWait}></AuditInformation>
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default ComplianceCertification;



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/compliancecertification/index.js